import MicroModal from 'micromodal';

export namespace RecipeDetail {
	let stopAllVideos = () => {
		let mif:HTMLIFrameElement = document.querySelector('.modal__iframe--rd');
		let originalSrc = mif.getAttribute('data-origsrc');
		mif.setAttribute('src', '#');
		mif.setAttribute('src', originalSrc);
	};
	let setupRecipeDetail = () => {
		let youtubePlayButton = document.querySelector('.js-rd-play');

		if(youtubePlayButton) {
			youtubePlayButton.addEventListener('click', (e) => {
				e.preventDefault();
			})
		}
	}

	let setupInstructionListItems = () => {
		let listItems = document.querySelectorAll('.recipe-detail__instructions ol li');

		if(listItems.length) {
			listItems.forEach((item) => {
				const div = document.createElement('div');
				div.innerHTML = item.innerHTML;
				item.innerHTML = '';
				item.appendChild(div);
			});
		}
	}

	export const init = () => {
		let modalItems = document.querySelectorAll('.js-rd-play');
		if(modalItems.length) {
			MicroModal.init({
				onClose: function() {
					stopAllVideos();
				}
			});
		}
		setupRecipeDetail();
		setupInstructionListItems();
	}
}


document.addEventListener('DOMContentLoaded', RecipeDetail.init);
